import { MainContentLayout } from 'shared/ui/layout';

import { EditCompany } from 'features/company/edit';

export function EditCompanyPage() {
  return <MainContentLayout element={<EditCompany />} />;
}
